"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreferredMediaUrl = void 0;
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("../Grid"));
var CardMedia_1 = __importDefault(require("../CardMedia"));
var MediaCard_1 = __importDefault(require("./MediaCard"));
var prism_icons_1 = require("@octanner/prism-icons");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_i18next_1 = require("react-i18next");
var ScrollLoader_1 = __importDefault(require("./ScrollLoader"));
var RenderSkeletonLoader_1 = __importDefault(require("./RenderSkeletonLoader"));
var styles_1 = require("./styles");
var DEFAULT_PAGE_SIZE = 4;
var getPreferredMediaUrl = function (url1, url2) {
    return (url1 && !url1.includes('.gif')) || (url2 && url2.includes('.gif'))
        ? url2 || url1
        : url1 || url2;
};
exports.getPreferredMediaUrl = getPreferredMediaUrl;
var MediaLibrary = function (_a) {
    var _b = _a.loading, loading = _b === void 0 ? false : _b, _c = _a.pageSize, pageSize = _c === void 0 ? DEFAULT_PAGE_SIZE : _c, _d = _a.data, data = _d === void 0 ? [] : _d, onShowMoreClick = _a.onShowMoreClick, onMediaSelect = _a.onMediaSelect, _e = _a.showMore, showMore = _e === void 0 ? false : _e, _f = _a.size, size = _f === void 0 ? 'auto' : _f, testid = _a["data-testid"], _g = _a.selectedMedia, selectedMedia = _g === void 0 ? null : _g, _h = _a.isFavorite, isFavorite = _h === void 0 ? function () { return false; } : _h, onFavorite = _a.onFavorite, _j = _a.variant, variant = _j === void 0 ? 'button' : _j;
    var _k = __read(react_1.default.useState(selectedMedia), 2), selected = _k[0], setSelected = _k[1];
    var _l = __read(react_1.default.useState(false), 2), isHovered = _l[0], setIsHovered = _l[1];
    var _m = __read(react_1.default.useState(false), 2), mediaLoadError = _m[0], setMediaLoadError = _m[1];
    var _o = __read(react_1.default.useState(false), 2), favoriteLoading = _o[0], setFavoriteLoading = _o[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var onLoadMore = function () {
        if (onShowMoreClick) {
            onShowMoreClick();
        }
    };
    var renderMedia = function () {
        return data.map(function (item) { return (react_1.default.createElement(Grid_1.default, { key: item === null || item === void 0 ? void 0 : item.title, item: true, xs: true },
            react_1.default.createElement(MediaCard_1.default, { key: item === null || item === void 0 ? void 0 : item.title, setSelected: setSelected, onMediaSelect: onMediaSelect, size: size, media: item, onFavorite: onFavorite, isFavorite: isFavorite }))); });
    };
    return (react_1.default.createElement(Box_1.default, { "data-testid": testid },
        !selected && (react_1.default.createElement(Box_1.default, null,
            variant === 'scroll' ? (react_1.default.createElement(styles_1.ScrollArea, { dataLength: data.length, loading: loading, id: "scrollArea" },
                react_1.default.createElement(styles_1.StyledBox, { size: size },
                    renderMedia(),
                    !(data.length > 0) && react_1.default.createElement(RenderSkeletonLoader_1.default, { pageSize: 16 })),
                showMore && (react_1.default.createElement(ScrollLoader_1.default, { size: size, pageSize: pageSize, load: onLoadMore })))) : (react_1.default.createElement(styles_1.StyledBox, { size: size },
                renderMedia(),
                loading && react_1.default.createElement(RenderSkeletonLoader_1.default, { pageSize: pageSize }))),
            showMore && variant !== 'scroll' && (react_1.default.createElement(styles_1.LoadButton, { "data-testid": "media-library-show-more", loading: loading, color: 'secondary', onClick: onLoadMore }, t('prism-header:show-more', 'Show more'))))),
        selected && (react_1.default.createElement(Box_1.default, { borderRadius: 3, position: "relative", onMouseEnter: function () { return setIsHovered(true); }, onMouseLeave: function () { return setIsHovered(false); } },
            react_1.default.createElement(styles_1.ActionButtonContainer, { isVideo: selected.mediaType === 'video' },
                react_1.default.createElement(styles_1.ActionButton, { disableRipple: true, disableFocusRipple: true, "aria-label": t('prism-header:remove', 'Remove'), color: "white", onClick: function () {
                        setSelected(null);
                        setMediaLoadError(false);
                        if (onMediaSelect) {
                            onMediaSelect(null);
                        }
                    } },
                    react_1.default.createElement(prism_icons_1.Trash, null)),
                onFavorite && (react_1.default.createElement(styles_1.FavoriteButton, { isFavorite: isFavorite === null || isFavorite === void 0 ? void 0 : isFavorite(selected), disableRipple: true, disableFocusRipple: true, color: "white", loading: favoriteLoading, "aria-label": (isFavorite === null || isFavorite === void 0 ? void 0 : isFavorite(selected))
                        ? t('prism-header:unfavorite', 'Unfavorite')
                        : t('prism-header:favorite', 'Favorite'), onClick: function (e) {
                        var _a;
                        var promise = onFavorite(selected);
                        if (promise) {
                            setFavoriteLoading(true);
                            (_a = promise.finally) === null || _a === void 0 ? void 0 : _a.call(promise, function () { return setFavoriteLoading(false); });
                        }
                        e.stopPropagation();
                    } }, (isFavorite === null || isFavorite === void 0 ? void 0 : isFavorite(selected)) ? react_1.default.createElement(prism_icons_1.HeartFilled, null) : react_1.default.createElement(prism_icons_1.Heart, null)))),
            selected.mediaType === 'img' ? (react_1.default.createElement(Box_1.default, { width: "100%" },
                react_1.default.createElement(CardMedia_1.default, { component: selected.mediaType, src: (0, exports.getPreferredMediaUrl)(selected.largeUrl, selected.normalUrl) ||
                        selected.thumbNailUrl, title: selected.title, onError: function () { return setMediaLoadError(true); } }),
                !mediaLoadError && (selected === null || selected === void 0 ? void 0 : selected.title) && (react_1.default.createElement(styles_1.StyledBackground, { mediaType: selected.mediaType },
                    react_1.default.createElement(styles_1.StyledName, null, selected.title))))) : (react_1.default.createElement(Box_1.default, { width: "100%" },
                react_1.default.createElement(styles_1.StyledVideoPlayer, { posterUrl: selected.largeUrl ||
                        selected.thumbNailUrl ||
                        selected.normalUrl, "aria-label": selected.title, videoUrl: selected.mediaUrl, onError: function () { return setMediaLoadError(true); } }),
                !mediaLoadError && !isHovered && (selected === null || selected === void 0 ? void 0 : selected.title) && (react_1.default.createElement(styles_1.StyledBackground, { mediaType: selected.mediaType },
                    react_1.default.createElement(styles_1.StyledName, { variant: "h4" }, selected.title)))))))));
};
exports.default = MediaLibrary;
//# sourceMappingURL=MediaLibrary.js.map